import React, { useCallback, useState, useEffect } from "react";
import { Form, Modal } from "@components";
import { Box, Button } from "@material-ui/core";
import { Manager } from "@components/form/state/types";
import { RoleModel, RoleApproverModel } from "@api/types/role";
import Select from "@material-ui/core/Select";
import { Field } from "../../../../../../components/form/fields/field";
import { Table } from "@components";
import api from "@api";
import {
  useBusinessTypeSelect,
  useSystemCategorySelect,
  useSystemAppNameSelect,
} from "@hooks";
import MenuItem from "@material-ui/core/MenuItem";
import { RoleApprover } from "./approver";
import { useRoleStore } from "../../../../../../store/hooksy";
import { alertService } from "@services";
import { createNonNullChain } from "typescript";

interface Props {
  open: boolean;
  onCancel: () => void;
  form: Manager<RoleModel>;
}

type Key = keyof RoleModel;

export const RoleDetail: React.FC<Props> = ({ open, onCancel, form }) => {
  const [, setRoleStore] = useRoleStore();

  const formRoleApproval = Form.useManager<RoleApproverModel>({
    id: 0,
    environment: "",
    approver2Email: "",
    approver3Email: "",
    approver4Email: "",
    approver1Level: "Manager",
    approver2Level: "",
    approver3Level: "",
    approver4Level: "",
    approverDistro2: null,
    approverDistro3: null,
    approverDistro4: null,
    role: 0,
    systemAppId: 0,
  });

  let role: RoleModel = {
    id: 0,
    roleName: "",
    systemAppName: "",
    description: "",
    systemAppNameId: 0,
    systemType: "",
    systemCategory: "",
    isActive: false,
  };

  function cancelSelectedData() {
    // role.id = 0;
    // role.roleName = "";
    // role.systemType = "";
    // role.systemCategory = "";
    // role.systemAppName = "";
    // role.systemAppNameId = 0;
    // role.isActive = false;
    // setSelectedSystemAppName(0);
    // setIsEmptySystemAppName(false);
    // systemCatAndType.systemType = "";
    // systemCatAndType.systemCategory = "";
    // formRoleApproval.reset();
    // // reset re-render flag to remove the is empty system app name error border
    // setIsFirstRender(true);
    onCancel();
    form.reset();
  }

  function clearModel() {
    cancelSelectedData();
    onCancel();
  }

  function clearAndClose() {
    form.reset();
    onCancel();
  }

  // // custom hooks
  // const {
  //   selectedCategory,
  //   categories,
  //   isFetchingCategories,
  //   setSelectedCategory,
  //   handleCategoryChange,
  // } = useSystemCategorySelect(form.values.systemCategory);

  // custom hooks
  const {
    systemAppNames,
    isFetchingSystemAppNames,
    selectedSystemAppName,
    setSelectedSystemAppName,
    handleSystemAppNameChange,
  } = useSystemAppNameSelect(form.values.systemAppNameId);

  // // custom hooks
  // const {
  //   selectedBusinessType,
  //   businessTypes,
  //   isFetchingbusinessTypes,
  //   setSelectedBusinessType,
  //   handleBusinessTypeChange,
  // } = useBusinessTypeSelect(form.values.systemType);

  const [isFetchingSystemCatAndType, setIsFetchingSystemCatAndType] = useState(
    false
  );
  const [systemCatAndType, setSystemCatAndType] = useState<any>({});

  useEffect(() => {
    if (selectedSystemAppName) {
      setIsFetchingSystemCatAndType(true);
      api.maintenancerole
        .getSystemTypeAndCategoryBySystemAppId(selectedSystemAppName)
        .then((response) => {
          setSystemCatAndType(response);
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          setIsFetchingSystemCatAndType(false);
        });
      formRoleApproval.values.systemAppId = selectedSystemAppName;
    }
  }, [selectedSystemAppName]);

  useEffect(() => {
    if (form.values.id) {
      formRoleApproval.set(Form.target.VALUE, ["role", form.values.id]);
      formRoleApproval.values.systemAppId = selectedSystemAppName;
    }
  }, [form.values.id]);

  const [isSubmitting, setSubmitting] = useState(false);

  const [isEmptySystemAppName, setIsEmptySystemAppName] = useState(false);
  const handleSubmitMainRoleDetail = useCallback(() => {
    if (!selectedSystemAppName) {
      setIsEmptySystemAppName(true);
    } else {
      setIsEmptySystemAppName(false);
    }
    if (!isEmptySystemAppName || selectedSystemAppName) {
      Promise.all(Object.entries(form.values).map(validate)).then(
        (validations) => {
          const valid = validations.reduce((valid, [name, error]) => {
            return valid && !error;
          }, true);
          if (valid) {
            submitData();
          } else {
            validations.forEach(([name, error]) => {
              form.set(Form.target.ERROR, [name, error]);
            });
          }
        }
      );
    }
  }, [form, selectedSystemAppName, isEmptySystemAppName]);

  function submitData() {
    role.id = form.values.id;
    role.roleName = form.values.roleName;
    role.description = form.values.description;
    role.systemAppNameId = selectedSystemAppName;
    role.isActive = form.values.isActive;
    setSubmitting(true);
    if (role.id !== 0) {
      // EDIT
      api.maintenancerole
        .put(role.id, role)
        .then((response) => {
          alertService.success({ msg: "Role has been successfully updated." });
          // clearSalesforceProfileModel();
        })
        .catch((error) => {
          if (error.response) {
            alertService.danger({ statusCode: error.response.status });
          }
        })
        .then(() => {
          setSubmitting(false);
          setRoleStore({ fetchList: true });
        });
    } else {
      // CREATE
      api.maintenancerole
        .post(role)
        .then((response) => {
          if (response) {
            alertService.success({ msg: "Role has been successfully saved." });
            form.set(Form.target.VALUE, ["id", response]);
            formRoleApproval.set(Form.target.VALUE, ["role", response]);
            formRoleApproval.values.systemAppId = selectedSystemAppName;
            // clearSalesforceProfileModel();
            setSubmitting(false);
          }
        })
        .catch((error) => {
          if (error.response) {
            alertService.danger({ statusCode: error.response.status });
          }
        })
        .then(() => {
          setSubmitting(false);
          setRoleStore({ fetchList: true });
        });
    }
  }

  function validate([name, value]: [string, any]): Promise<[Key, Error?]> {
    switch (name) {
      case "roleName":
        return Promise.resolve([name as Key, Form.Validators.hasValue(value)]);
      default:
        return Promise.resolve([name as Key]);
    }
  }

  function onChange(name: Key, value: any): void {
    form.set(Form.target.VALUE, [name, value]);
    validate([name, value]).then(([name, error]) => {
      form.set(Form.target.ERROR, [name, error]);
    });
  }

  const modalTitle = form.values.id !== 0 ? "Update" : "Add New";
  const submitText = "Submit";

  // let categoriesMenu = null;
  // if (isFetchingCategories) {
  //   categoriesMenu = <MenuItem value={0}>Please wait...</MenuItem>;
  // } else {
  //   categoriesMenu = categories.map((item: any, key) => (
  //     <MenuItem key={key} value={item.value}>
  //       {item.label}
  //     </MenuItem>
  //   ));
  // }

  // let businessTypeMenu = null;
  // if (isFetchingbusinessTypes) {
  //   businessTypeMenu = <MenuItem value={0}>Please wait...</MenuItem>;
  // } else {
  //   businessTypeMenu = businessTypes.map((item: any, key) => (
  //     <MenuItem key={key} value={item.value}>
  //       {item.label}
  //     </MenuItem>
  //   ));
  // }

  let systemAppNameMenu = null;
  if (isFetchingSystemAppNames) {
    systemAppNameMenu = <MenuItem value={0}>Please wait...</MenuItem>;
  } else {
    systemAppNameMenu = systemAppNames.map((item: any, key) => (
      <MenuItem key={key} value={item.value}>
        {item.label}
      </MenuItem>
    ));
  }

  let createUpdateButton = "";
  if (isSubmitting) {
    createUpdateButton = "Submitting...";
  } else {
    createUpdateButton = form.values.id ? "Update" : "Create";
  }

  let cancelSelectedDataButton = null;
  let closeButton = null;
  if (form.values.id) {
    cancelSelectedDataButton = (
      <Button variant="outlined" type="button" onClick={cancelSelectedData}>
        Cancel
      </Button>
    );
  } else {
    cancelSelectedDataButton = null;
    closeButton = (
      <Button
        variant="outlined"
        color="primary"
        onClick={() => clearAndClose()}
      >
        Close
      </Button>
    );
  }

  const [isFirstRender, setIsFirstRender] = useState(true);
  useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(false);
    } else {
      if (selectedSystemAppName) {
        setIsEmptySystemAppName(false);
      } else {
        setIsEmptySystemAppName(true);
      }
    }
  }, [selectedSystemAppName]);

  return (
    <Modal
      isOpen={open}
      title={`${modalTitle} Role`}
      closeModal={() => clearAndClose()}
      size="md"
    >
      <Form>
        <Form.Textbox
          label="Role Name"
          name="roleName"
          onChange={onChange}
          size={6}
          error={form.errors.roleName}
          value={form.values.roleName}
          required
        />
        <Field label="System App Name *" size={6}>
          <Select
            style={isEmptySystemAppName ? { borderColor: "red" } : {}}
            value={selectedSystemAppName}
            onChange={handleSystemAppNameChange}
            disabled={isFetchingSystemAppNames}
          >
            {systemAppNameMenu}
          </Select>
        </Field>
        <Form.Textbox
          label="System Type"
          name="systemType"
          size={6}
          value={
            isFetchingSystemCatAndType
              ? "Please wait..."
              : systemCatAndType.systemType
          }
          disabled
        />
        <Form.Textbox
          label="System Category"
          name="systemCategory"
          size={6}
          value={
            isFetchingSystemCatAndType
              ? "Please wait..."
              : systemCatAndType.systemCategory
          }
          disabled
        />
        <Form.Textarea
          label="Description"
          name="description"
          rows={5}
          rowsMax={5}
          size={6}
          error={form.errors.description}
          value={form.values.description}
          onChange={onChange}
        />
        {/* <Field label="System Category" size={6}>
          <Select
            value={selectedCategory}
            onChange={handleCategoryChange}
            disabled={isFetchingCategories}
          >
            {categoriesMenu}
          </Select>
        </Field> */}
        <Form.Checkbox
          label="Is Active"
          name="isActive"
          onChange={onChange}
          size={4}
          value={form.values.isActive}
        />
        <Field label="" size={3}>
          <Button
            variant="contained"
            color="primary"
            type="button"
            disabled={isSubmitting}
            onClick={handleSubmitMainRoleDetail}
          >
            {createUpdateButton}
          </Button>
        </Field>
        <Field label="" size={2}>
          {cancelSelectedDataButton}
        </Field>
      </Form>
      <br />
      {form.values.id ? <RoleApprover form={formRoleApproval} /> : null}
      <Box textAlign="right" mt={4}>
        {closeButton}
      </Box>
    </Modal>
  );
};
